import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_ModelConstantRow,
} from "../PA.Core/PAdbSchemaRows";
import {IwbModelConstant} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Model_Constant,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class ModelConstantBO implements IBusinessObject {
    Identity: IdentityProvider

    CreateOptions: any

    LoadOptions: any
    _bIsLoaded: boolean
    _OnLoadComplete: Promise<IBusinessObject>
    LoadProgressProvider: IProgressProvider

    ValidateOptions: any
    _bIsValidated: boolean
    ValidateMessageProvider: IMessageProvider
    ValidateProgressProvider: IProgressProvider

    SaveOptions: any
    _bIsSaved: boolean
    SaveProgressProvider: IProgressProvider

    DeleteOptions: any
    _bIsDeleted: boolean
    DeleteMessageProvider: IMessageProvider
    DeleteProgressProvider: IProgressProvider

    dbContext: PAdbContext
    drWB_ModelConstant: WB_ModelConstantRow

    constructor(options?: any) {
        this.CreateOptions = options || {}

        if ('dbContext' in this.CreateOptions) this.dbContext = this.CreateOptions.dbContext

        this.Identity = new IdentityProvider({ id: 0, name: 'New Model Constant' })

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._OnLoadComplete = null
        this.LoadProgressProvider = new ProgressProvider('Loading', this)

        this.ValidateOptions = {}
        this._bIsValidated = false
        this.ValidateMessageProvider = new MessageProvider()
        this.ValidateProgressProvider = new ProgressProvider('Validating', this)

        this.SaveOptions = {}
        this._bIsSaved = false
        this.SaveProgressProvider = new ProgressProvider('Saving', this)

        this.DeleteOptions = {}
        this._bIsDeleted = false
        this.DeleteMessageProvider = new MessageProvider()
        this.DeleteProgressProvider = new ProgressProvider('Deleting', this)

        this.drWB_ModelConstant = null
    }

    get WB_ModelConstant(): WB_ModelConstantRow {
        return this.drWB_ModelConstant
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this
        this.LoadProgressProvider.start('Creating Model Constant')
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            self.LoadOptions = options || {}
            if ('dbContext' in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
            else self.dbContext = new PAdbContext()

            if (this.dbContext == null) {
                let sError = 'Unable to determine dbContext for new Model Constant.'
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            // Create record using dbContext
            this.dbContext
                .createRecordWithKey(esWB_Model_Constant)
                .then((newModelConstantRow: WB_ModelConstantRow) => {
                    newModelConstantRow.setDefaults()
                    self.drWB_ModelConstant = newModelConstantRow
                    self.dbContext.add(esWB_Model_Constant, newModelConstantRow)
                    self.Identity.setAll(
                        self.WB_ModelConstant.cif.WB_MODEL_CONSTANT_ID,
                        self.WB_ModelConstant.cif.CONSTANT_ID,
                        self.WB_ModelConstant.cif.CONSTANT_NAME
                    )
                    self.LoadProgressProvider.setName('Loading ' + self.Identity.name + '(' + self.Identity.id_ui + ')')
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelConstant,
                        'WB_MODEL_CONSTANT_ID',
                        'CONSTANT_ID',
                        'CONSTANT_NAME'
                    )
                    self.LoadProgressProvider.finish()
                    self._bIsLoaded = true
                    self._OnLoadComplete = null
                    resolve(self)
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })
        })

        return this._OnLoadComplete
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        const self = this

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start('Loading (' + self.Identity.id_ui + ')')

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            if (self.bIsLoaded) {
                let sError = 'Model Constant already loaded.'
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            self.LoadOptions = options || {}

            if ('dbContext' in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
            else if (self.dbContext == null) self.dbContext = new PAdbContext()

            if (this.dbContext == null) {
                let sError = 'Unable to determine dbContext for Model Constant.'
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ModelConstantBO.createRecordResolver({ dbContext: self.dbContext })
                recordResolverLoadPromise = ModelConstantBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newModelConstantRow: any = recordResolver.get(esWB_Model_Constant, anId)

                    if (_.isEmpty(newModelConstantRow)) {
                        self._OnLoadComplete = null
                        self.LoadProgressProvider.exception('Id not found.')
                        resolve(self)
                        return
                    }

                    self.drWB_ModelConstant = newModelConstantRow
                    self.Identity.setAll(
                        self.WB_ModelConstant.cif.WB_MODEL_CONSTANT_ID,
                        self.WB_ModelConstant.cif.CONSTANT_ID,
                        self.WB_ModelConstant.cif.CONSTANT_NAME
                    )
                    self.LoadProgressProvider.setName('Loading ' + self.Identity.name + '(' + self.Identity.id_ui + ')')
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelConstant,
                        'WB_MODEL_CONSTANT_ID',
                        'CONSTANT_ID',
                        'CONSTANT_NAME'
                    )
                })
                .then((newModelConstantRow: any) => {
                    self._bIsLoaded = true
                    self._OnLoadComplete = null
                    self.LoadProgressProvider.finish()
                    resolve(self)
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })
        })

        return this._OnLoadComplete
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded
    }

    Validate(options?: any): Promise<IBusinessObject> {
        let self = this
        this.ValidateMessageProvider.clearMessages()
        this.ValidateProgressProvider.start(
            'Validating ' + self.WB_ModelConstant.cif.CONSTANT_NAME + '(' + self.WB_ModelConstant.cif.CONSTANT_ID + ')'
        )
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {}

            if (self.dbContext == undefined) {
                let sError = 'Unable to determine dbContext to Validate Model Constant.'
                self.ValidateProgressProvider.exception(sError)
                reject(sError)
            }

            self._bIsValidated = true
            self.ValidateProgressProvider.finish()
            resolve(self)
        })
    }

    get bIsValidated(): boolean {
        return this._bIsValidated
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this
        const wbModelConstant = <IwbModelConstant>self.drWB_ModelConstant
        this.SaveProgressProvider.start(
            'Saving ' + wbModelConstant.CONSTANT_NAME + '(' + wbModelConstant.CONSTANT_ID + ')'
        )

        try {
            if (_.isEmpty(self.dbContext)) {
                self._bIsSaved = false
                let sError = 'Unable to determine dbContext to Save Model Constant.'
                self.SaveProgressProvider.exception(sError)
                return self
            }

            self.SaveOptions = options || {}
            if(self.WB_ModelConstant.cif.USAGE != 'Cannibalization'){
                self.WB_ModelConstant.bAffinitySetInd = false
                self.WB_ModelConstant.bAggressorSubModelInd = false
                self.WB_ModelConstant.bVictimSubModelInd = false
            }

            let saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any
            ) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_Model_Constant, self.drWB_ModelConstant, {})

            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true
                })
            } else {
                self._bIsSaved = true
            }
            self.SaveProgressProvider.finish()
            return self
        } catch (err) {
            self.SaveProgressProvider.exception(err)
            return self
        }
    }

    get bIsSaved(): boolean {
        return this._bIsSaved
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this
        const wbModelConstant = <IwbModelConstant>self.drWB_ModelConstant
        this.DeleteMessageProvider.clearMessages()
        this.DeleteProgressProvider.start(
            'Deleting ' + wbModelConstant.CONSTANT_NAME + '(' + wbModelConstant.CONSTANT_ID + ')'
        )

        return new Promise<IBusinessObject>((resolve, error) => {
            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ModelConstant.markDeleted()

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true
                        self.DeleteProgressProvider.finish()
                        resolve(self)
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true
                self.DeleteProgressProvider.finish()
                resolve(self)
            }
        })
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted
    }

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext
        } else {
            dbContext = new PAdbContext({})
        }

        const modelConstant_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {}
        }

        const aRecResolver = new ESRecordResolver(dbContext, modelConstant_options)

        return aRecResolver
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_Model_Constant, ids)
                .then((result) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass( ModelConstantBO , "ModelConstantBO", "Model Constant")
